// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1In9F","left":"styles_left__1LsLP","desktopActions":"styles_desktopActions__7nNL_","title":"styles_title__1kxY6"};